module.exports = __webpack_public_path__ + "static/lighthouse.fb551f68.jpg";